import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { 
  BarChart3, 
  MessageSquare, 
  Bot,
  ChartLine
} from 'lucide-react';

const ResultsDropdownMobile = ({ activeTab, onTabChange }) => {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  
  const navigationItems = [
    {
      id: 'Insights',
      label: 'Survey summary stats',
      icon: BarChart3
    },
    {
      id: 'Responses',
      label: 'Individual responses',
      icon: MessageSquare
    },
    {
      id: 'Overview',
      label: 'Analyze results',
      icon: ChartLine
    },
    {
      id: 'Research Assistant',
      label: 'Research Assistant',
      icon: Bot
    }
  ];
  
  // Find active tab
  const activeTabObject = navigationItems.find((t) => t.id === activeTab);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropDownOpen && !event.target.closest(".results-dropdown")) {
        setIsDropDownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropDownOpen]);

  return (
    <div className="results-dropdown">
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsDropDownOpen((prev) => !prev)}
          className="w-full px-4 h-14 text-sm flex items-center justify-between hover:bg-gray-50 transition-colors"
        >
          <span className="font-medium text-gray-900 flex-1 text-center">{activeTabObject?.label}</span>
          {activeTabObject?.badge && (
            <span className="bg-yellow-100 text-yellow-800 px-1.5 py-0.5 text-xs font-normal rounded-full mr-2">
              {activeTabObject.badge}
            </span>
          )}
          <ChevronRight
            size={18}
            className={`text-gray-400 transition-transform duration-200 flex-shrink-0 ${
              isDropDownOpen ? "rotate-[270deg]" : "rotate-90"
            }`}
          />
        </button>

        {isDropDownOpen && (
          <div className="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
            {navigationItems.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  className={`w-full px-4 py-3.5 hover:bg-gray-50 transition-colors border-b border-gray-100 text-left last:border-b-0 flex items-center gap-3 ${
                    activeTab === tab.id ? 'bg-blue-50 text-blue-900' : 'text-gray-700'
                  }`}
                  onClick={() => {
                    onTabChange(tab.id);
                    setIsDropDownOpen(false);
                  }}
                >
                  <Icon size={18} className={activeTab === tab.id ? 'text-blue-700' : 'text-gray-600'} />
                  <h3 className="text-sm font-medium flex-1">{tab.label}</h3>
                  {tab.badge && (
                    <span className="bg-yellow-100 text-yellow-800 px-1.5 py-0.5 text-xs font-normal rounded-full">
                      {tab.badge}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultsDropdownMobile;

